module.exports = __webpack_public_path__ + "img/wanfangLogo2.258faf8c.png";